export default __webpack_public_path__ + "static/media/strategyEng1.d2a79a64.jpg";